<template>
  <div>
    <el-card>
      <h5>Barangay Electoral Insights</h5>
      <bar-chart :labels="labels" :height="250" :extra-options="activityChart.options" :datasets="datasets" v-if="show">
      </bar-chart>

      <!-- Legend -->
      <div class="legend">
        <span class="legend-item">
          <span class="legend-color" style="background-color: #fcc468;"></span> Total Voters
        </span>
        <span class="legend-item">
          <span class="legend-color" style="background-color: #6bd098;"></span> Validated
        </span>
        <span class="legend-item">
          <span class="legend-color" style="background-color: #4acccd;"></span> Voted
        </span>
        <span class="legend-item">
          <span class="legend-color" style="background-color: #ef8157;"></span> Voted Straight
        </span>
     
      </div>

    </el-card>
  </div>
</template>

<script>

import BarChart from 'src/components/UIComponents/Charts/BarChart'

const tooltipOptions = {
  tooltipFillColor: "rgba(0,0,0,0.5)",
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipFontSize: 14,
  tooltipFontStyle: "normal",
  tooltipFontColor: "#fff",
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipTitleFontSize: 14,
  tooltipTitleFontStyle: "bold",
  tooltipTitleFontColor: "#fff",
  tooltipYPadding: 6,
  tooltipXPadding: 6,
  tooltipCaretSize: 8,
  tooltipCornerRadius: 6,
  tooltipXOffset: 10,
};

export default {
  props: ['collection'],
  components: {
    BarChart
  },
  data() {
    return {
      show: false,
      labels: [],
      datasets: [],
      activityChart: {
        options: {
          tooltips: tooltipOptions
        }
      },
    }
  },
  watch: {
    collection: function () {
      setTimeout(() => {
      this.initChart();
    }, 500); // 500ms delay
    }
  },
  created: function () {
    this.initChart()
  },
  methods: {
    initChart() {
      let labels = []
      let totalVoters = []
      let voted = []
      let votedStraight = []
      let validated = []

      this.datasets = []

      this.collection.forEach(item => {
        labels.push(item.name)
        totalVoters.push(item.total_voters)
        voted.push(item.voted)
        votedStraight.push(item.voted_straight)
        validated.push(item.validated)
      });

      this.labels = labels
      this.datasets = [
        {
          label: "Total Voters",
          borderColor: '#fcc468',
          fill: true,
          backgroundColor: '#fcc468',
          hoverBorderColor: '#fcc468',
          borderWidth: 8,
          data: totalVoters,
        },
        {
          label: "Validated",
          borderColor: '#6bd098',
          fill: true,
          backgroundColor: '#6bd098',
          hoverBorderColor: '#6bd098',
          borderWidth: 8,
          data: validated,
        },
        {
          label: "Voted",
          borderColor: '#4acccd',
          fill: true,
          backgroundColor: '#4acccd',
          hoverBorderColor: '#4acccd',
          borderWidth: 8,
          data: voted,
        },
        {
          label: "Voted Straight",
          borderColor: '#ef8157',
          fill: true,
          backgroundColor: '#ef8157',
          hoverBorderColor: '#ef8157',
          borderWidth: 8,
          data: votedStraight,
        },
      ]

      this.show = true
    }
  }
}
</script>

<style scoped>
.legend {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
</style>